import { useNavigate, useParams } from 'react-router-dom'
import {
  FCRCalendarContainer,
  FCRCollectionTableItem,
  FCRCollectionTableWrapper,
  FCRParentContainer,
  FCRSelectButton,
} from './FeeCollectionReportStyles'
import { MentorProfileContext } from 'src/mentor/context/MentorProfileContext'
import { useContext, useEffect, useState } from 'react'
import { getDataWithParams } from 'src/consumer/services/profileService'
import { Spinner } from 'react-bootstrap'
import {
  OFFLINE_PAYMENT_METHODS_LIST,
  currency_list,
  platformOptions,
} from 'src/consumer/constants'
import dayjs from 'dayjs'
import Calendar from 'react-calendar'
import SwapVertIcon from '@mui/icons-material/SwapVert'
import { CSmartTable } from '@coreui/react-pro'

export default function FeeCollectionReportPage() {
  const { clinicId } = useParams()
  const { mentorProfileData, mentorClinicAssociationData } = useContext(MentorProfileContext)

  return (
    <div style={{ width: '100%', padding: '30px 10px' }}>
      <div style={{ marginBottom: '20px', textAlign: 'center' }}>
        <b>Fee Collection Report</b>
      </div>
      <FeeCollectionReportComponent
        mentorData={mentorProfileData}
        mentorClinicAssociationData={mentorClinicAssociationData}
        getDataFunction={getBookingsFunction}
        clinicId={clinicId}
      />
    </div>
  )
}

function FeeCollectionReportComponent({
  mentorData,
  mentorClinicAssociationData,
  getDataFunction,
  clinicId,
}) {
  const todayDate = new Date()
  const oldestDate = new Date()
  oldestDate?.setMonth(todayDate?.getMonth() - 12)

  const [durationFilterType, setDurationFilterType] = useState('date') // date, range
  const [selectedDate, setSelectedDate] = useState(new Date()) // selected date, keep timezone as usertimezone
  const [selectedDateRange, setSelectedDateRange] = useState() //{ startTime: '', endTime: '' }
  const [clinicType, setClinicType] = useState() // clinicId, "allClinic", "nonClinic"
  const [loading, setLoading] = useState(false)
  const [loadedData, setLoadedData] = useState([])
  const [totalFeePaymentString, setTotalFeePaymentString] = useState('')
  const [calendarsVisible, setCalendarsVisible] = useState(false)
  const [defaultDirection, setDefaultDirection] = useState(true)
  const navigate = useNavigate()

  async function setThingsUp() {
    setLoading(true)
    setLoadedData([])
    setTotalFeePaymentString('')

    let startDateTimeForApiCall
    let endDateTimeForApiCall

    if (durationFilterType === 'date') {
      startDateTimeForApiCall = dayjs(selectedDate)?.startOf('day')?.utc()?.format()
      endDateTimeForApiCall = dayjs(selectedDate)?.endOf('day')?.utc()?.format()
    } else if (durationFilterType === 'range') {
      startDateTimeForApiCall = dayjs(selectedDateRange?.startTime)
        ?.startOf('day')
        ?.utc()
        ?.format()
      endDateTimeForApiCall = dayjs(selectedDateRange?.endTime)?.endOf('day')?.utc()?.format()
    } else {
      startDateTimeForApiCall = dayjs()?.startOf('day')?.utc()?.format()
      endDateTimeForApiCall = dayjs()?.endOf('day')?.utc()?.format()
    }

    let responseList = await getDataFunction(startDateTimeForApiCall, endDateTimeForApiCall)
    if (clinicType === 'allClinic') {
      responseList = responseList?.filter((item) => true)
    } else {
      responseList = responseList?.filter((item) => item?.clinicId === clinicType)
    }
    if (!defaultDirection) {
      responseList.reverse()
    }
    setLoadedData(responseList)
    const proposedPaymentMapObject = {}
    responseList?.forEach((item) => {
      if (item?.currency) {
        proposedPaymentMapObject[item.currency] = [
          item?.feePaid,
          ...(proposedPaymentMapObject?.[item?.currency] || []),
        ]
      } else {
        proposedPaymentMapObject['inr'] = [
          item?.feePaid,
          ...(proposedPaymentMapObject?.unknown || []),
        ]
      }
    })
    let proposedTotalFeePaymentString = ''
    let currenciesArray = Object?.keys(proposedPaymentMapObject)
    currenciesArray?.forEach((currency, currencyIndex) => {
      var sum = proposedPaymentMapObject?.[currency].reduce((acc, curr) => {
        return acc + curr
      }, 0)
      proposedTotalFeePaymentString += `${
        currency_list?.find((item) => item?.code === currency)?.symbol
      }${sum} (${currency_list?.find((item) => item?.code === currency)?.name}) ${
        currencyIndex !== currenciesArray?.length - 1 ? ' + ' : ''
      }`
    })
    setTotalFeePaymentString(proposedTotalFeePaymentString)
    setLoading(false)
  }

  useEffect(() => {
    if (clinicId) {
      setClinicType(clinicId)
    } else {
      setClinicType('allClinic')
    }
    const startDateForRange = new Date()
    const endDateForRange = new Date()
    startDateForRange?.setMonth(endDateForRange?.getMonth() - 1)
    setSelectedDateRange({
      startTime: startDateForRange,
      endTime: endDateForRange,
    })
  }, [])

  useEffect(() => console.log(loadedData), [loadedData])
  useEffect(() => {
    setThingsUp()
  }, [selectedDate, selectedDateRange, durationFilterType, clinicType, defaultDirection])

  let aumhumCollectedFeeBreakup = {}
  let clinicCollectedFeeBreakup = {}

  loadedData
    ?.filter((item) => item?.feePaymentMode === 'aumhum')
    ?.forEach((item) => {
      aumhumCollectedFeeBreakup[item?.currency] = [
        item?.feePaid,
        ...(aumhumCollectedFeeBreakup?.[item?.currency] || []),
      ]
    })

  loadedData
    ?.filter((item) => item?.feePaymentMode !== 'aumhum')
    ?.forEach((item) => {
      clinicCollectedFeeBreakup[item?.currency || 'inr'] = [
        item?.feePaid,
        ...(clinicCollectedFeeBreakup?.[item?.currency || 'inr'] || []),
      ]
    })

  return (
    <FCRParentContainer>
      <div style={{ padding: '20px' }}>
        <b>Name: {mentorData?.name}</b>
      </div>
      <div style={{ padding: '20px', background: '#ececec' }}>
        {/* Report Duration:  */}
        <div style={{ marginBottom: '30px' }}>
          <b>Report Duration: </b>
          <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
            <FCRSelectButton
              selected={durationFilterType === 'date'}
              onClick={() => setDurationFilterType('date')}
            >
              Selected Date
            </FCRSelectButton>
            <FCRSelectButton
              selected={durationFilterType === 'range'}
              onClick={() => setDurationFilterType('range')}
            >
              Selected Date Range
            </FCRSelectButton>
          </div>
        </div>
        {/* Selected Date */}
        {durationFilterType === 'date' && (
          <div style={{ marginBottom: '30px' }}>
            <b>Selected Date: </b>
            <div>
              {dayjs(selectedDate, 'YYYY-MM-DD')?.format('DD MMM YYYY')}
              {'  '}
              <span
                style={{ cursor: 'pointer' }}
                onClick={() => setCalendarsVisible((prev) => !prev)}
              >
                <u>{calendarsVisible ? 'Hide Calendar' : 'Choose Date'}</u>
              </span>
            </div>
            {calendarsVisible && (
              <FCRCalendarContainer>
                <Calendar
                  onChange={(nextValue) => setSelectedDate(nextValue)}
                  value={selectedDate}
                  minDate={oldestDate}
                  maxDate={todayDate}
                  minDetail="decade"
                  showNeighboringMonth={false}
                  locale={sessionStorage.getItem('languageCode') || 'en'}
                />
              </FCRCalendarContainer>
            )}
          </div>
        )}
        {/* Selected Date Range */}
        {durationFilterType === 'range' &&
          selectedDateRange?.startTime &&
          selectedDateRange?.endTime && (
            <div style={{ marginBottom: '30px' }}>
              <b>Selected Date Range: </b>
              <div>
                {dayjs(selectedDateRange?.startTime, 'YYYY-MM-DD')?.format('DD MMM YYYY')} to{' '}
                {dayjs(selectedDateRange?.endTime, 'YYYY-MM-DD')?.format('DD MMM YYYY')}
                {'  '}
                <span
                  style={{ cursor: 'pointer' }}
                  onClick={() => setCalendarsVisible((prev) => !prev)}
                >
                  <u>{calendarsVisible ? 'Hide Calendar' : 'Choose Date'}</u>
                </span>
              </div>
              {calendarsVisible && (
                <div
                  style={{ display: 'flex', flexWrap: 'wrap', gap: '20px', alignItems: 'center' }}
                >
                  <FCRCalendarContainer>
                    <Calendar
                      onChange={(nextValue) =>
                        setSelectedDateRange((prev) => ({ ...prev, startTime: nextValue }))
                      }
                      value={selectedDateRange?.startTime}
                      minDate={oldestDate}
                      maxDate={todayDate}
                      minDetail="decade"
                      showNeighboringMonth={false}
                      locale={sessionStorage.getItem('languageCode') || 'en'}
                    />
                  </FCRCalendarContainer>
                  <div>
                    <b>To</b>
                  </div>
                  <FCRCalendarContainer>
                    <Calendar
                      onChange={(nextValue) =>
                        setSelectedDateRange((prev) => ({ ...prev, endTime: nextValue }))
                      }
                      value={selectedDateRange?.endTime}
                      minDate={selectedDateRange?.startTime}
                      maxDate={todayDate}
                      minDetail="decade"
                      showNeighboringMonth={false}
                      locale={sessionStorage.getItem('languageCode') || 'en'}
                    />
                  </FCRCalendarContainer>
                </div>
              )}
            </div>
          )}
        {/* Clinic Selection */}
        <div style={{ marginBottom: '30px' }}>
          <b>Clinic: </b>
          <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
            <FCRSelectButton
              selected={clinicType === 'allClinic'}
              onClick={() => setClinicType('allClinic')}
            >
              ALL
            </FCRSelectButton>
            {mentorClinicAssociationData?.map((clinicItem, clinicItemIndex) => {
              return (
                <FCRSelectButton
                  selected={clinicType === clinicItem?.id}
                  onClick={() => setClinicType(clinicItem?.id)}
                  key={clinicItemIndex}
                >
                  {clinicItem?.title}
                </FCRSelectButton>
              )
            })}
          </div>
        </div>
      </div>
      {loading ? (
        <div style={{ padding: '20px' }}>
          <Spinner animation="border" variant="dark" size="sm" />
        </div>
      ) : (
        <>
          <div style={{ padding: '20px' }}>
            <div>
              <b>Total Sessions: </b>
              {loadedData?.length || 0}
            </div>
            <div>
              <b>Fees Collected: </b>
              {totalFeePaymentString}
            </div>
          </div>
          <div style={{ padding: '20px', background: '#ececec' }}>
            <div>
              <b>Payouts and Actions:</b>
            </div>
            <div style={{ marginTop: '20px' }}>
              <div>
                <b>Collected by Clinic:</b>
              </div>
              <div>
                {Object.keys(clinicCollectedFeeBreakup)?.length > 0 ? (
                  <ToRenderPayoutComponent data={clinicCollectedFeeBreakup} allData={loadedData} />
                ) : (
                  'No Collections'
                )}
              </div>
              <div>
                <b>Collected by AUMHUM:</b>
              </div>
              <div>
                {Object.keys(aumhumCollectedFeeBreakup)?.length > 0 ? (
                  <ToRenderPayoutComponent data={aumhumCollectedFeeBreakup} allData={loadedData} />
                ) : (
                  'No Collections'
                )}
              </div>
            </div>
          </div>
          <div className="overflow-hidden" style={{ padding: '20px' }}>
            <div style={{ marginBottom: '30px' }}>
              <b>Collection Details</b>
            </div>
            <SmartTableComponent
              loadedData={loadedData}
              mentorClinicAssociationData={mentorClinicAssociationData}
              platformOptions={platformOptions}
              currency_list={currency_list}
              OFFLINE_PAYMENT_METHODS_LIST={OFFLINE_PAYMENT_METHODS_LIST}
            />
          </div>
        </>
      )}
    </FCRParentContainer>
  )
}

async function getBookingsFunction(startDate, endDate) {
  const response = await getDataWithParams('/api/secure/teacher/booked-slots/all', {
    startTime: startDate,
    endTime: endDate,
  })
  if (response.status === 200 && Array.isArray(response?.data)) {
    return response?.data
  }
  return []
}

function ToRenderPayoutComponent({ data, allData }) {
  const refundedEventsData = allData?.filter((item) => item?.discountAction?.discountedPrice)
  const refundedTotalAmount = refundedEventsData.reduce(
    (acc, curr) => acc + (curr?.feePaid - curr?.discountAction?.discountedPrice),
    0,
  ) // should take into account currency also

  return (
    <>
      <div>Before Discounts: </div>
      {Object.keys(data)?.map((dataItem, dataItemIndex) => {
        const sum = data[dataItem].reduce((acc, curr) => acc + curr, 0)
        return (
          <div key={dataItemIndex}>
            {currency_list?.find((item) => item?.code === dataItem)?.symbol}
            {sum}
          </div>
        )
      })}
      <div>Discounts given: {refundedTotalAmount}</div>
    </>
  )
}

const SmartTableComponent = ({
  loadedData,
  mentorClinicAssociationData,
  platformOptions,
  currency_list,
  OFFLINE_PAYMENT_METHODS_LIST,
}) => {
  const tableData = loadedData?.map((bookingItem, bookingItemIndex) => {
    const formattedDate = moment
      .utc(bookingItem?.createdTime || bookingItem?.startTime)
      ?.local()
      ?.format('DD MMM, YYYY HH:mm:ss')

    const medium = OFFLINE_PAYMENT_METHODS_LIST?.find(
      (item) => item?.id === bookingItem?.feePaymentMode,
    )?.title || ''

    const collectedBy = bookingItem?.feePaymentMode === 'aumhum' ? 'AUMHUM' : 'Clinic'

    const clinic = mentorClinicAssociationData?.find(
      (item) => item?.id === bookingItem?.clinicId,
    )?.title || ''

    // const reference = bookingItem?.patientId || ''
    const reference = bookingItem?.userName || ''

    const mode = platformOptions?.find((item) => item?.id === bookingItem?.meetingSrc)?.name || ''

    const currencySymbol = currency_list?.find(
      (item) => item?.code === bookingItem?.currency,
    )?.symbol || ''
    const amountText =
      `${currencySymbol}${bookingItem?.feePaid || ''}` +
      (bookingItem?.discountAction?.discountedPrice
        ? ` (After Discount: ${currencySymbol}${bookingItem?.discountAction?.discountedPrice || ''})`
        : '')

    return {
      srNo: bookingItemIndex + 1,
      date: formattedDate,
      medium: medium,
      collectedBy: collectedBy,
      reference: reference,
      clinic: clinic,
      mode: mode,
      amount: amountText,
    }
  })

  console.log(tableData)

  const collectionDetailColumns = [
    {
      key: 'srNo',
      label: 'Sr.No.',
      _style: { minWidth: '130px' },
      filter: false,
      sorter: false,
    },
    {
      key: 'date',
      label: 'Date',
      _style: { minWidth: '130px' },
      filter: false,
      sorter: false,
    },
    {
      key: 'medium',
      label: 'Medium',
      _style: { minWidth: '130px' },
      filter: false,
      sorter: false,
    },
    {
      key: 'collectedBy', 
      label: 'Collected By',
      _style: { minWidth: '120px' },
      filter: false,
      sorter: false,
    },
    {
      key: 'reference',
      label: 'Reference',
      _style: { minWidth: '130px' },
      filter: false,
      sorter: false,
    },
    {
      key: 'clinic',
      label: 'Clinic',
      _style: { minWidth: '130px' },
      filter: false,
      sorter: false,
    },
    {
      key: 'mode',
      label: 'Mode',
      _style: { minWidth: '130px' },
      filter: false,
      sorter: false,
    },
    {
      key: 'amount',
      label: 'Amount',
      _style: { minWidth: '130px' },
      filter: false,
      sorter: false,
    },
  ]

  return (
    <div className="overflow-auto">
      <CSmartTable columns={collectionDetailColumns} items={tableData} itemsPerPage={10000000000000000} />
    </div>
  )
}